import * as moment from "moment";
export const orgCols = [
  "Наименование учреждения",
  "Фактический адрес",
  "ИНН",
  "Тип",
  "ГРБС",
  "Руководитель",
];

export const colorTag = {
  1: "red",
  2: "green",
  3: "yellow",
};

export const yesOrNo = {
  true: "Да",
  false: "Нет",
};

export const currentYear = moment().year();
export const arrOfYear = [currentYear + 1, currentYear + 2, currentYear + 3];

export const decodeTitle = `РАСШИФРОВКА К СПРАВКЕ СОГЛАСОВАНИЯ ЛИМИТОВ ПОТРЕБЛЕНИЯ
          ТОПЛИВНО-ЭНЕРГЕТИЧЕСКИХ РЕСУРСОВ И ВОДЫ В НАТУРАЛЬНОМ И СТОИМОСТНОМ
          ВЫРАЖЕНИИ`;

export const convertedDateToYear = (date: moment.MomentInput) =>
  +moment(date).format("YYYY");

export const disabledDateFromStartToEnd = (
  current: any,
  start: string | moment.Moment,
  end: string | moment.Moment,
) => {
  if (current < moment(start)) {
    return true;
  } else if (current > moment(end)) {
    return true;
  } else {
    return false;
  }
};

export const linkStyle = {
  color: "#56B4A4",
  textDecoration: "underline",
};

export const stylesDiv = {
  display: "flex",
  alignItems: "center",
  gap: "15px",
  justifyContent: "space-between",
};

export const stylesDivFlex = {
  display: "flex",
  alignItems: "center",
  gap: "15px",
};

export const disabledDataCorrection = (current: {
  format: (arg0: string) => any;
}) => {
  const curr = current.format("M");
  if (curr > 0 && curr < 4) {
    return true;
  }
  return false;
};

export const stylesDivRO = {
  display: "flex",
  alignItems: "center",
  gap: "15px",
  marginBottom: "10px",
};

export const actTltle = {
  1: "Перейти на справку", /// ЭБ на три года
  2: "Перейти на протокол", /// ЭБ на текущий год
  3: "Перейти на протокол", /// Корректировочный протокол
  4: "Перейти на отчет", /// Отчет о фактическом потреблении
};

export const getIsPrice = (id: number) => [3, 6, 10, 11].includes(id);
export const processUnitMeasure = (text: string) => text.replace('тыс.', '').trim();//убираем тыс. принудительно

// (Темп роста первого полугодия*Доля потребления первого полугодия+Темп роста второго полугодия*Доля потребления второго полугодия)
export const getTariffValue = (
  prop1: { value: number },
  prop2: { value: number },
  prop3: { value: number },
  prop4: { value: number },
) => prop1.value * prop2.value + prop3.value * prop4.value;
